import clsx from 'clsx';
import { h } from 'preact';
import SubMenuItems from './submenu-items';

const SubMenuTabs = ({
  menu,
  activeMenu,
  activeTab,
  setActiveTab,
  setActiveMenu,
}) => {
  const tabsHeadings = menu.map((m) => m.title);

  return (
    <div className="flex items-start justify-start gap-[47px] pb-10">
      <div className="flex-[0_0_200px] flex flex-col rounded-[4px] border border-black-30 overflow-hidden">
        {tabsHeadings.map((title, index) => (
          <div key={`${title}-${index}`}>
            <p
              className={clsx(
                'cursor-pointer px-6 pt-4 pb-3 cta-small uppercase',
                activeTab === index && 'text-black bg-cream-grey',
                activeTab !== index && 'text-charcoal bg-neutral',
              )}
              onClick={() => {
                setActiveTab(index);
                setActiveMenu(menu[index].submenus);
              }}
            >
              {title}
            </p>
          </div>
        ))}
      </div>
      <SubMenuItems menu={activeMenu} />
    </div>
  );
};

export default SubMenuTabs;
